module.exports = __webpack_public_path__ + "img/waiting-approve.9f4c188f.svg";